module.exports = __webpack_public_path__ + "img/arrow-left-blue.b8e1ae79.svg";